import { Link } from "react-router-dom";
import { Youtube, Instagram, Mail, MessageCircle, Send } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import Logo from "./Logo";

function TikTok(props) {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" {...props}>
      <path d="M16.5 3c.3 2 1.7 3.6 3.5 3.9v2.6c-1.3 0-2.6-.4-3.7-1.1v6.9c0 3.4-2.8 6.2-6.2 6.2S3.9 18.7 3.9 15.3s2.8-6.2 6.2-6.2c.3 0 .6 0 .9.1v2.7c-.3-.1-.6-.1-.9-.1a3.5 3.5 0 100 7 3.5 3.5 0 003.5-3.5V3h2.9z" />
    </svg>
  );
}

export default function Footer() {
  const { settings } = useSite();
  const socials = [
    { href: settings.youtube_url, icon: Youtube, label: "YouTube" },
    { href: settings.tiktok_url, icon: TikTok, label: "TikTok" },
    { href: settings.instagram_url, icon: Instagram, label: "Instagram" },
    { href: (settings.telegram_link_enabled ? settings.telegram_link : ""), icon: Send, label: "Telegram" },
    { href: settings.whatsapp_link, icon: MessageCircle, label: "WhatsApp" },
  ].filter((s) => s.href);

  return (
    <footer className="relative border-t border-white/10 bg-[#0A0A0A] mt-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-1">
          <Logo />
          <p className="mt-4 text-sm text-white/55 leading-relaxed max-w-xs">
            Helping complete beginners create content on their phone and grow with confidence.
          </p>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] mb-4">Explore</h4>
          <ul className="space-y-2 text-sm text-white/70">
            <li><Link to="/services" className="hover:text-[#D4AF37]">Services</Link></li>
            <li><Link to="/content-plans" className="hover:text-[#D4AF37]">Content Plans</Link></li>
            <li><Link to="/free-resources" className="hover:text-[#D4AF37]">Free Resources</Link></li>
            <li><Link to="/gear" className="hover:text-[#D4AF37]">Recommended Gear</Link></li>
            <li><Link to="/community" className="hover:text-[#D4AF37]">Community</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] mb-4">Legal</h4>
          <ul className="space-y-2 text-sm text-white/70">
            <li><Link to="/legal/privacy" className="hover:text-[#D4AF37]">Privacy Policy</Link></li>
            <li><Link to="/legal/terms" className="hover:text-[#D4AF37]">Terms & Conditions</Link></li>
            <li><Link to="/legal/refund" className="hover:text-[#D4AF37]">Refund Policy</Link></li>
            <li><Link to="/legal/affiliate" className="hover:text-[#D4AF37]">Affiliate Disclosure</Link></li>
            <li><Link to="/legal/earnings" className="hover:text-[#D4AF37]">Earnings Disclaimer</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] mb-4">Get in touch</h4>
          <div className="space-y-3 text-sm text-white/70">
            {settings.contact_email && (
              <a href={`mailto:${settings.contact_email}`} className="flex items-center gap-2 hover:text-[#D4AF37]">
                <Mail size={16} /> {settings.contact_email}
              </a>
            )}
            {settings.whatsapp_link && (
              <a href={settings.whatsapp_link} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-[#D4AF37]">
                <MessageCircle size={16} /> {settings.whatsapp_number}
              </a>
            )}
          </div>
          <div className="flex gap-3 mt-5">
            {socials.map((s) => (
              <a key={s.label} href={s.href} target="_blank" rel="noreferrer" aria-label={s.label}
                 data-testid={`footer-social-${s.label.toLowerCase()}`}
                 className="grid place-items-center h-10 w-10 rounded-full border border-white/15 text-white/80 hover:text-[#0A0A0A] hover:bg-[#D4AF37] hover:border-[#D4AF37] transition-colors duration-300">
                <s.icon size={18} />
              </a>
            ))}
          </div>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs text-white/40 px-4">
        © {new Date().getFullYear()} Qwerjoh Media. Results and earnings vary and are never guaranteed. ·{" "}
        <Link to="/admin" className="hover:text-[#D4AF37]">Admin</Link>
      </div>
    </footer>
  );
}
